/**
 * セッション切れの状態
 *
 * 最初の 401 で立てる。消えるのは、ログイン画面への移動（ページの読み込み直し）と、
 * ブラウザの「戻る」「進む」で back/forward cache からページが復元されたとき。
 * 移動が終わるまでの間に、ポーリングやログ送信が 401・429 を重ね、
 * nginx のレート制限と fail2ban による IP 遮断（6時間）を招くのを防ぐ。
 */

let sessionExpired = false;

const markSessionExpired = (): void => {
  sessionExpired = true;
};

const isSessionExpired = (): boolean => sessionExpired;

/**
 * back/forward cache から復元されたページは、読み込み直しを経ずに状態を引き継ぐ。
 * セッション切れのまま通信を止め続けないよう、復元時に消す。セッションがまだ切れていれば、次の 401 で再び立つ。
 */
const clearSessionExpiredOnPageRestore = (event: PageTransitionEvent): void => {
  if (event.persisted) {
    sessionExpired = false;
  }
};

/**
 * 復元時にセッション切れの記録を消す処理を登録する。戻り値は登録を外す関数
 */
const setupSessionExpiryResetOnPageRestore = (): (() => void) => {
  window.addEventListener('pageshow', clearSessionExpiredOnPageRestore);
  return () => window.removeEventListener('pageshow', clearSessionExpiredOnPageRestore);
};

export { markSessionExpired, isSessionExpired, setupSessionExpiryResetOnPageRestore };
